export default __webpack_public_path__ + "static/media/filter-1.3cee4998.png";